module.exports = __webpack_public_path__ + "static/media/infoBackground.e22079d9.svg";